<template>
  <div class="core-strengths flex-box">
    <div class="title">{{title}}</div>
    <div class="description">{{description}}</div>
    <div class="advantage-list flex-box">
      <mobile-tab-fold :tabs="foldTabs" :value="activeVal" @input="onFoldTab" />
      <div class="list">
        <div 
          class="list-item" 
          :class="{'is-active': activeVal === item.val}"
          v-for="(item, k) in topList" 
          :key="k" 
          @click="schemeClick(item)"
        >
          <div class="item-title">{{ item.title }}</div>
        </div>
      </div>
      <div class="content">
        <div class="content-description" v-if="schemeInfo.description">{{ schemeInfo.description }}</div>
        <el-image
          class="preview-shot"
          fit="contain"
          :src="schemeInfo.contentImg"
          :preview-src-list="previewImgs"
        />
      </div>
    </div>

  </div>
</template>

<script>
import MobileTabFold from '@/components/MobileTabFold/index.vue'
import hxys1 from '@/assets/images/hxys1.jpg'
import hxys2 from '@/assets/images/hxys2.png'
import hxys3 from '@/assets/images/hxys3.png'
import hxys4 from '@/assets/images/hxys4.png'
import hxys5 from '@/assets/images/hxys5.png'
import hxys6 from '@/assets/images/hxys6.png'
import hxys7 from '@/assets/images/hxys7.png'

export default {
  components: { MobileTabFold },
  props: {
    title: {
      type: String,
      default: '璞华PMS的核心优势'
    },
    description: {
      type: String,
      default: '璞华PMS使制造业产品研发项目过程更透明，协同更高效、决策更准确'
    },
    otherTopList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      schemeInfo: {},
      oldTopList: [
        {
          val: '01',
          title: '个人工作台',
          contentImg: hxys1,
        },
        {
          val: '02',
          title: '项目独立建模',
          contentImg: hxys2,
        },
        {
          val: '03',
          title: '多级计划管理',
          contentImg: hxys3,
        },
        {
          val: '04',
          title: '多维进度管理',
          contentImg: hxys4,
        },
        {
          val: '05',
          title: '多样化流程配置',
          contentImg: hxys5,
        },
        {
          val: '06',
          title: '灵活的权限配置',
          contentImg: hxys6,
        },
        {
          val: '07',
          title: '可视化数据决策支持',
          contentImg: hxys7,
        }
      ],
      activeVal: '01',
    }
  },
  computed: {
    topList({ oldTopList, otherTopList }) {
      if(otherTopList.length) return otherTopList
      return oldTopList
    },
    foldTabs() {
      return this.topList.map(item => ({
        name: item.val,
        label: item.title
      }))
    },
    previewImgs() {
      return this.topList.map(item => item.contentImg).filter(Boolean)
    }
  },
  created() {
    this.schemeInfo = this.topList[0]
  },
  methods: {
    schemeClick(item) {
      this.schemeInfo = item
      this.activeVal = item.val
    },
    onFoldTab(name) {
      const item = this.topList.find(entry => entry.val === name)
      if (item) this.schemeClick(item)
    }
   
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.core-strengths { 
  padding: 9rem 11.7rem 8.8rem 18.2rem;
  background: linear-gradient( 168deg, #FBFCFD 0%, #F4F7F9 100%);
  flex-direction: column;
  align-items: center;

  .title {
    font-size: 4rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 4rem;
    margin-bottom: 2.4rem;
  }

  .description {
    font-size: 1.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666A77;
    line-height: 1.8rem;
    margin-bottom: 7.2rem;
  }

  .advantage-list {
    width: 100%;
    .list {
      margin-right: 3.2rem;
      .list-item {
        width: 40rem;
        background: #FFFFFF;
        box-shadow: 0rem 1rem 3.7rem 0rem rgba(196,199,202,0.2);
        padding: 3.6rem 2.9rem;
        cursor: pointer;
        position: relative;
        margin-bottom: 2.4rem;
        &:last-child {
          margin-bottom: 0;
        }
        .item-title {
          line-height: 2.2rem;
          font-size: 2.2rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #333333;
        }
        &.is-active {
          background: linear-gradient(318deg, #0F81F4 0%, #37A4FF 100%);
          box-shadow: 0rem 1rem 3.7rem 0rem rgba(15,129,244,0.2);
          .item-title {
            color: #FFFFFF;
          }
        }
      }
    }
  }
  .content {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    .content-description {
      font-size: 2rem;
      margin-bottom: 2rem;
    }
    img,
    ::v-deep .preview-shot {
      width: 100%;
      height: 100%;
      display: block;
      cursor: zoom-in;
    }
    ::v-deep .preview-shot .el-image__inner {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .core-strengths {
    padding: 4.8rem 1.6rem;
    .title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      text-align: center;
    }
    .description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      margin-bottom: 2.4rem;
      text-align: center;
    }
    .advantage-list {
      flex-wrap: wrap;
      .list {
        display: none;
      }
      ::v-deep .mobile-tab-fold {
        padding: 0;
        margin: 0 0 1.6rem;
        flex: 1 1 100%;
        width: 100%;
        max-width: 100%;
      }
    }
    .content {
      width: 100%;
    }
    .content img,
    .content ::v-deep .preview-shot,
    .content ::v-deep .preview-shot .el-image__inner {
      height: auto;
    }
  }
}
</style>
